import http from "./http-service"
import moment from "@/utils/moment"

export default class InvoiceService {

  static getById(branch, id, series) {
    return http.get(`invoices/${branch}/${id}/${series}`)
  }

  static getCustomerInvoices(data) {

    let url = `customer-invoices/${data.customerCode}/${data.customerUnit}?`

    url += `startDate=${moment(data.startDate).format("YYYY-MM-DD")}&`
    url += `endDate=${moment(data.endDate).format("YYYY-MM-DD")}`

    return http.get(url).then((response) => response.invoices)
  }

  static getOrderInvoices(branch, orderId) {
    return http.get(`order-invoices/${branch}/${orderId}`).then((response) => response.invoices)
  }
}